import { colors } from 'modules/app/styles'
import { AccordionItem } from 'react-accessible-accordion'
import styled, { css } from 'styled-components'

export const ResponsesDrawer = styled.section`
  height: calc(100% - 44px);
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const ResponseList = styled.div`
  margin: 0;
  padding: 0px;
  list-style: none;
  height: calc(100% - 64px);
  overflow-y: auto;

  .section-name {
    font-size: 12px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .category-form {
    .actionButtons {
      display: flex;
      align-items: center;
      .action {
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 15px;
        cursor: pointer;
        color: #8c8c8c;
        &:hover {
          color: #444;
        }
      }
    }
  }
`

export const NotFoundBox = styled.div`
  display: block;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const FooterButton = styled.div`
  padding: 16px;
  box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.07);
  margin-top: auto;
  .btn-group {
    width: 100%;
  }
`
export const OnList = styled.li`
  padding: 8px 10px;
  user-select: none;
  list-style: none;
  position: relative;
  font-size: 12px;
  background: ${colors['lightest-blue']};

  &.active{
    & a{
      color: ${colors['main-blue']};
    }
  }

  &.child {
    border-radius: 4px;
    margin: 4px 8px;
    border: 1px solid #c8d1e6;
    &.hover,
    &:hover {
      border-color: ${colors['main-blue']};
    }
  }
  .sortHandleBox {
    font-weight: 600;
    min-width: 17px;
    text-align: center;
    font-size: 12px;
    .dragIcon {
      cursor: grab;
      color: darkgray;
    }
  }
  .response-preview {
    font-family: 'Raleway', 'Segoe UI', Helvetica, Arial, sans-serif; 
    width: 100%;
    display: flex;

    .action-buttons {
      position: absolute;
      top: 0;
      right: 4px;
      &.rtl {
        right: auto;
        left: 15px;
      }
      height: 100%;
      background: #fff;
      padding-right: 16px;
      display: none;
      align-items: center;
      &:before {
        content: '';
        position: absolute;
        width: 15px;
        height: 100%;
        right: 100%;
        top: 0;
        background: rgb(255, 255, 255);
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.5021358885351015) 0%, rgba(255, 255, 255, 1) 100%, rgba(0, 212, 255, 1) 100%);
      }

      &.arrow:after{
        content: '';
        position: absolute;
        border: 6px solid transparent;
        border-right-color: #0d55ff;
        top: 23px;
        right: 5px;
      }
      &.btn-group {
        // z-index: 1;
      }
    }

    &.hover .action-buttons,
    &:hover .action-buttons,
    .action-buttons.show {
      display: flex;
    }
  }
  &.sorting-item {
    z-index: 20;
    .sortHandleBox {
      cursor: grab;
    }
  }

  &.disabled {
    pointer-events: none;
    .show-upgrade-button {
      display: flex;
    }
    .action-buttons {
      background: none;
      pointer-events: all;
      &:before {
        display: none;
      }
      &.btn-group button.dropdown-toggle.rounded-border {
        border-radius: 30px;
        width: 32px;
      }
    }
  }
`

export const ResponsePreview = styled.div`
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  p.heading,
  div.text {
    white-space: pre-line;
    word-break: break-all;
    display: block;
    transition: color 0.4s;
  }
  p.heading {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 600;
    color: #000;
    width: 100%;
    margin-bottom: 0 !important;
    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
    }
  }
  .text {
    font-size: 14px;
    color: #000;
    width: 100%;
    display: inline-block;
    margin-bottom: 0;
    & > .fr-view {
      position: relative;
      max-height: 23px;
      width: 100%;
      overflow: hidden;
      opacity: 0.6;
      font-weight: normal;
      text-align: start;
    }
    &.ellipsis {
      line-height: 1.3rem;
      & > .fr-view:after {
        content: '...';
        position: absolute;
        bottom: 0px;
        right: -4px;
        width: 3em;
        margin-left: 0;
        padding-right: 10px;
        background: #fcfcff;
        background: linear-gradient(to right, #fcfcff00, #fcfcff00 50%, #fcfcff00);
        text-align: right;
      }
    }
  }

  // Freemium disabled
  &.disabled {
    pointer-events: none;
    .show-upgrade-button {
      display: flex;
    }
  }
`
export const ResponseItemMenu = styled.div`
  z-index: 9981;
  visibility: hidden;
  position: absolute;
  min-width: 100%;
  opacity: 0;
  transition: 0.3s;
  min-width: 150px;
  right: 0;
  ul {
    margin: 0;
    margin-bottom: 15px;
    padding: 0;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    border-radius: 4px;
    overflow: hidden;
  }
  li {
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 8px;
    color: #00263a;
    transition: 0.1s;
    font-weight: normal;
    cursor: pointer;
    border-bottom: 1px solid #e1e5e9;
    &:hover {
      background-color: #eeeeef;
    }
    &.delete {
      color: #fc7348;
      .menuIcon {
        color: #fc7348;
      }
    }
    .menuIcon {
      font-size: 14px;
      margin-right: 4px;
      color: #939aa9;
    }

    &.category-item {
      svg {
        width: 17px;
        height: 17px;
      }
      &.disabled {
        cursor: not-allowed;
        color: #6c757d;
        span {
          cursor: not-allowed !important;
        }
      }
    }
  }
  &.open {
    visibility: visible;
    opacity: 1;
  }
`
export const AccordionItemStyled = styled(AccordionItem)`
  user-select: none;
  background: #fff;
  position: relative;
  & > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  &.sorting-item {
    z-index: 20;
    .sortHandleBox {
      cursor: grab;
    }
  }

  &.is-dragging-hover:before {
    content: '';
    top: -5px;
    bottom: -10px;
    left: 0;
    right: 0;
    position: absolute;
    background: ${colors['light-blue-200']};
  }

  .accordionItemHeading {
    width: 100%;
  }
  .accordionItemButton {
    position: relative;
    outline: none;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    .sortHandleBox {
      font-weight: 600;
      min-width: 17px;
      text-align: center;
      font-size: 12px;
      .dragIcon {
        cursor: grab;
        color: darkgray;
      }
    }
    .categoryName-wrapper {
      padding: 8px 10px;
      width: 100%;
      display: flex;
      align-items: center;
    }
    .expandButton {
      border-radius: 3px;
      width: 19px;
      min-width: 19px;
      height: 19px;
      text-align: center;
      svg {
        fill: ${colors['main-text']};
      }
      &.expanded,
      &:hover {
        background: ${colors['blue-100']};
      }
    }
    .categoryName {
      margin: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
      max-width: calc(100% - 33px);
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      svg {
        width: 20px;
        min-width: 20px;
        height: 20px;
      }

      &.active{
        & span{
          color: ${colors['main-blue']}
        }
      }
    }
    &:hover .actionButtons {
      display: flex;
    }
    .more-button-dropdown {
      position: absolute;
      right: 8px;
      button.toggle {
        background: ${colors['light-blue-100']};
        border-radius: 20px;
        padding: 5px;
        width: 24px;
        height: 24px;
        @media (max-width: 1024px) {
          display: flex;
        }
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }
    &:hover .more-button-dropdown button.toggle {
      display: flex;
    }
  }

  .AccordionItemPanel.pages {
    background: ${colors['lightest-blue']};
    border-bottom: 1px solid #e3e7f0;
  }

  // Sub category
  &.child {
    margin: 0;
    ${(props) => {
    if (props.level > 0) {
      return css`
          margin-left: ${props.level * 20}px;
        `
    }
  }}
    background: none;
    &:first-of-type {
      margin-top: 0;
    }
    & > div {
      min-height: unset;
    }
    .accordionItemButton {
      border: none;
    }
    .AccordionItemPanel {
      background: none;
      position: relative;
      border-bottom: none;
      &:not(.noline):before {
        content: '';
        left: 44px;
        top: 0;
        height: 100%;
        width: 1px;
        background: #c8d1e6;
        position: absolute;
      }
    }
  }
`

export const ResponseCount = styled.span`
  font-size: 12px;
  -webkit-text-fill-color: ${colors['text-secondary']};
  color: ${colors['text-secondary']};
  font-weight: 600;
  line-height: 1;
  margin-left: 10px;
`
export const ResponseDelete = styled.div`
  display: flex;
  align-items: center;
  padding: 0 5px;
  .imgPanel {
    width: 36px;
  }
  .textPanel {
    flex: 1;
    margin: 0 8px;
    p.heading {
      margin-bottom: 0px;
      margin-top: 0px;
      font-size: 14px;
      width: 100%;
      font-weight: 600;
    }
    p.text {
      font-size: 12px;
      margin-top: 0px;
      color: #878b8f;
      margin-bottom: 0;
    }
  }
  .buttonPanel {
    flex: 1 1;
    margin-top: 0;
    display: flex;
    flex-direction: column;
    max-width: 80px;
    .deleteBtn {
      background-image: linear-gradient(to right, #d84136, #fe7a7a);
      color: #ffffff;
      border-radius: 25px;
      padding: 6px 15px;
      font-weight: 100;
      border: none;
    }
    .cancelBtn {
      margin-top: 7px;
      cursor: pointer;
      border: 0;
      background: none;
    }
  }
`
export const UnCategorizedPages = styled.section`
  position: relative;
  &.is-dragging-hover {
    background: ${colors['light-blue-200']};
  }
`

export const ShortcutBadge = styled.span`
  padding: 0 8px;
  background: #ecf2ff;
  border-radius: 32px;
  font-size: 12px;
  font-weight: 600;
  color: ${colors['main-blue']};
  text-align: center;
  text-transform: none;
  border: 1px solid #C1D4FF;
  display: flex;
  align-items: center;
  white-space: nowrap;
`
